<div [formGroup]="form">
<!--    <prettyjson [obj]="form.value"></prettyjson>-->
  <h2 class="rounded rounded-2 text-center"> Follow Up Education Assessment</h2>
  <div class="row" *ngIf="editMode">
    <mat-form-field appearance="outline" class="col-md-3">
      <mat-label>Centre Name</mat-label>
      <input matInput [value]="mData?.centreName" readonly>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-3">
      <mat-label>Child Name</mat-label>
      <input matInput [value]="mData?.childName" readonly>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-3">
      <mat-label>Assessment No.</mat-label>
      <input matInput [value]="mData?.sessionType" readonly>
    </mat-form-field>&nbsp;
    <mat-form-field appearance="outline" class="col-md-2">
      <mat-label>Choose a date</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="date" readonly>
      <mat-hint>DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="row">
      <mat-form-field *ngIf="!editMode" appearance="outline" class="col-md-3">
        <mat-label>Centre</mat-label>
        <mat-select (selectionChange)="onCentreSelect($event)">
          <mat-option *ngFor="let c of (_centres$ | async)" [value]="c">{{ c.centreName }}</mat-option>
          <mat-option value="All">All Centres</mat-option>
        </mat-select>
      </mat-form-field>
      <app-searchable-select *ngIf="!editMode" class="col-md-3"
                             [multiple]="false"
                             [options]="filteredChildren"
                             [selectedValue]="selectedChild"
                             [valueKey]="'childCode'"
                             [displayWithFn]="displayChild"
                             [placeholder]="'Select Child'"
                             [label]="'Select Child'"
                             (selectionChange)="searchChild($event)"
      ></app-searchable-select>
      <mat-form-field appearance="outline" *ngIf="!editMode" class="col-md-3">
      <mat-label>Assessment No.</mat-label>
      <mat-select formControlName="sessionType">
        <mat-option *ngFor="let a of assessmentTypes" [value]="a"> {{ a }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" *ngIf="!editMode" class="col-md-3">
      <mat-label>Choose a date</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="date">
      <mat-hint>DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>

  <mat-card class="mt-2">
    <h2 class="rounded rounded-2 text-center">Questions</h2>

    <div formArrayName="questions">
      <ng-container *ngFor="let f of formArray.controls; let i = index">

        <div *ngIf="shouldShowQuestion(i)" [formGroupName]="i">

          <h3>{{ questionList[i].question }}</h3>
          <div class="row" *ngIf="questionList[i].isRadioBtn">
            <mat-radio-group
              class="col-md-6"
              formControlName="ans"
              (change)="onAnswerChange(i)">
              <mat-radio-button value="Yes">Yes</mat-radio-button>&nbsp;
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="formArray.at(i).get('ans')?.invalid && formArray.at(i).get('ans')?.touched"
                       class="col-md-12">
              Please select an answer
            </mat-error>
          </div>
          <div class="row" *ngIf="questionList[i].remarkType === 'dropdown'">
            <div class="col-6">
              <div class="col-md-12">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{ questionList[i].dropdownLabel }}</mat-label>
                  <mat-select formControlName="remarkDropdown">
                    <mat-option
                      *ngFor="let opt of questionList[i].options"
                      [value]="opt.value">
                      {{ opt.value }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="formArray.at(i).get('remarkDropdown')?.hasError('required')">
                    Please select an option
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-12" *ngIf="questionList[i].hideRemark === false">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Enter The Remark</mat-label>
                  <textarea
                    matInput
                    formControlName="remark"
                    rows="2"
                    placeholder="Write your remark here...">
      </textarea>
                  <mat-error *ngIf="formArray.at(i).get('remark')?.hasError('required')">
                    Remark is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

          </div>

          <div class="row" *ngIf="questionList[i].remarkType === 'text'">
            <div class="col-md-6">
              <mat-form-field class="w-100" appearance="outline">
                <mat-label>Enter The Remark</mat-label>
                <textarea
                  matInput
                  formControlName="remark"
                  rows="2"
                  placeholder="Write your remark here...">
      </textarea>
                <mat-error *ngIf="formArray.at(i).get('remark')?.hasError('required')">
                  Remark is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <hr>
        </div>

      </ng-container>
    </div>

    <div class="d-flex justify-content-center">
      <button mat-raised-button color="warn" (click)="cancel()">Cancel</button>&nbsp;&nbsp;
      <button mat-raised-button color="primary" (click)="Submit()" [disabled]="form.invalid">
        Submit
      </button>
    </div>
  </mat-card>


</div>
